// /**
//  * Created by wzs on 2022/5/20.
//  */

import api from '@/services/api'
import commonEnum from "@/config/commonEnum"
import ShareIcon from '@/assets/images/share/share-icon.jpg'
import {wxJsapiSignatureUsingGET} from "../services/api/wxController";
let retryCount = 5
let wxReady = false;
//默认分享内容
let shareTitle = '';
let shareDesc = '';
let shareLink =  location.href;
let imgUrl = ShareIcon;
let shareCB = null;//朋友圈或发送给好友分享回调方法，四个事件：trigger fail cancel success
console.log("location.origin",)
export let initWxConfig = async function () {
    const resp = await api.wxController.wxJsapiSignatureUsingGET({
        url: encodeURIComponent(location.href)
    })
    if (resp?.code === commonEnum.ResponseCode.SUCCESS) {
        let data = resp?.data
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            openTagList: ['wx-open-subscribe']
        });
    }
};


const rebindShareInfo = function () {

    //获取“分享给朋友”按钮点击状态及自定义分享内容接口
    console.log('shareLink:' + shareLink);
    wx.onMenuShareAppMessage({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareLink, // 分享链接
        imgUrl: imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        trigger: function (res) {
            if (shareCB) shareCB('trigger')
        },
        success: function (res) {
            if (shareCB) shareCB('success')
        },
        cancel: function (res) {
            if (shareCB) shareCB('cancel')
        },
        fail: function (res) {
            if (shareCB) shareCB('fail')
        }
    });
    //alert('已注册获取“发送给朋友”状态事件');

    //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
    wx.onMenuShareTimeline({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareLink, // 分享链接
        imgUrl: imgUrl, // 分享图标
        trigger: function (res) {
            if (shareCB) shareCB('trigger')
        },

        success: function (res) {
            if (shareCB) shareCB('success')
        },
        cancel: function (res) {
            if (shareCB) shareCB('cancel')
        },
        fail: function (res) {
            if (shareCB) shareCB('fail')
        }
    });
    //alert('已注册获取“分享到朋友圈”状态事件');
};


wx.ready(function () {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
    // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，
    // 则可以直接调用，不需要放在ready函数中。
    wxReady = true;
    rebindShareInfo();
    console.log("wx.ready");
});

wx.error(function (res) {
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，
    // 也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    //alert("wx.error: " + res.config);
    //
    console.log("wx.error.res: " , res);
    console.log("wx.error: " + res.config);
    retryCount -= 1;
    if (retryCount > 0) {
        setTimeout(function () {
            initWxConfig();
        }, 500);
    }
    console.log("retryCount: " + retryCount)
});
